const KEY = 'suika-clone-best';

export function getBest(): number {
  const v = Number(localStorage.getItem(KEY));
  return Number.isFinite(v) ? v : 0;
}

export function setBest(score: number): number {
  const best = getBest();
  if (score > best) {
    try { localStorage.setItem(KEY, String(score)); } catch { /* ignore */ }
    return score;
  }
  return best;
}
